import { FileText } from "@phosphor-icons/react";
import { Button } from "./ui/button";
import { Label } from "./ui/label";

const MONTHS = Array.from({ length: 12 }, (_, index) => ({
  label: new Date(2026, index, 1).toLocaleString("en", { month: "long" }),
  value: index + 1,
}));

export const ReportFilters = ({ filters, onChange, onSearch, scopes, user }) => {
  const years = [
    new Date().getFullYear(),
    new Date().getFullYear() - 1,
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 3,
  ];
  const defaultScopeLabel = user.role === "admin" ? "Whole company" : "My personal sales";

  return (
    <section className="report-filters">
      <div>
        <Label htmlFor="report-year">Year</Label>
        <select
          id="report-year"
          data-testid="report-year-select"
          value={filters.year}
          onChange={(event) => onChange("year", event.target.value)}
        >
          <option value="">All Years</option>
          {years.map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
      </div>
      <div>
        <Label htmlFor="report-month">Month</Label>
        <select
          id="report-month"
          data-testid="report-month-select"
          value={filters.month}
          onChange={(event) => onChange("month", event.target.value)}
        >
          <option value="">All Months</option>
          {MONTHS.map((month) => (
            <option key={month.value} value={month.value}>{month.label}</option>
          ))}
        </select>
      </div>
      <div>
        <Label htmlFor="report-agent">Agent ID</Label>
        <select
          id="report-agent"
          data-testid="report-agent-select"
          value={filters.ownerId}
          onChange={(event) => onChange("ownerId", event.target.value)}
        >
          <option value="">
            {defaultScopeLabel}
          </option>
          {scopes.map((scope) => (
            <option key={scope.id} value={scope.id}>
              {scope.name}{scope.is_self ? " · Me" : ""}
            </option>
          ))}
        </select>
      </div>
      <Button onClick={onSearch} data-testid="report-search-button">
        <FileText size={16} /> Search
      </Button>
      <label className="void-toggle" htmlFor="show-void-toggle">
        <input
          id="show-void-toggle"
          type="checkbox"
          checked={filters.includeVoid}
          onChange={(event) => onChange("includeVoid", event.target.checked)}
          data-testid="show-void-toggle"
        />
        Show Void Records
      </label>
    </section>
  );
};